// extracted by mini-css-extract-plugin
export default {"shadowed":"Home_shadowed__MF90p","hand":"Home_hand__ZhErq","wave":"Home_wave__h32ZV"};